import Icon from './Icon.tsx';
import url from '@assets/images/shipment.svg';

const ShipmentIcon = () => {
  return <Icon icon={url} className="relative flex flex-col justify-center" />;
};

export default ShipmentIcon;
